import { AppForm } from '../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { ApplicationAppEntityApplicationWrite, ParcelAppEntityParcelWrite } from '../../../../../../openapi';
import { FormControl, Validators } from '@angular/forms';

@Injectable()
export class PropertyDataForm extends AppForm {
  constructor() {
    super({
      parcels: new FormControl<ParcelAppEntityParcelWrite[]>(
        [], {
          nonNullable: true,
          validators: [Validators.required, Validators.minLength(1), Validators.maxLength(255)]
        }
      )
    });
  }

  public get street(): FormControl | null {
    return this.get('street') as FormControl | null;
  }

  public createStreetControl(): void {
    this.addControl('street', new FormControl(null, [Validators.maxLength(255)]));
  }

  public get houseNumber(): FormControl | null {
    return this.get('houseNumber') as FormControl | null;
  }

  public createHouseNumberControls(): void {
    this.addControl('houseNumber', new FormControl(null));
  }

  public get parcels(): FormControl {
    return this.get('parcels') as FormControl;
  }

  public get parcelsValues(): ParcelAppEntityParcelWrite[] {
    return this.parcels.value;
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    let value = this.value;
    delete value.parcels;
    return value;
  }
}
